import { AnalyticsBrowser } from "@segment/analytics-next";

if (!process.env.NEXT_PUBLIC_SEGMENT_WRITE_KEY) {
  throw new Error("NEXT_PUBLIC_SEGMENT_WRITE_KEY is not set");
}

export const clientAnalytics = AnalyticsBrowser.load({
  writeKey: process.env.NEXT_PUBLIC_SEGMENT_WRITE_KEY,
  cdnURL: "https://tcdn.getuserfeedback.com",
});
